'use client';

import * as React from 'react';
import EditPermissionModalContent from '@/app/dashboard/staff-settings/permissions/components/edit-permission-modal-content';
import { useAppSelector } from '@/store/hooks';
import { getUi } from '@/store/reducers/ui-slice';

import { ModalDrawer } from '@/types/general';

import { ModalLayout } from '../core/modal-layout';

export function EditPermissionModal(): React.JSX.Element | null {
  const { modal } = useAppSelector(getUi);

  if (!modal?.content) return null;

  return (
    <ModalLayout title="Edit Permission" isOpen={modal?.open === ModalDrawer.EDIT_PERMISSION}>
      <EditPermissionModalContent />
    </ModalLayout>
  );
}
